export default {
  title: 'Recommended for you',
  match: 'Match: ',
};
